import script from "./DialogBubble.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogBubble.vue?vue&type=script&setup=true&lang=js"

import "./DialogBubble.vue?vue&type=style&index=0&id=edb22c96&lang=scss"

const __exports__ = script;

export default __exports__